import { IPagination } from "src/models/interfaces/pagination";

export const defaultPagination: IPagination = { Limit: 5, Offset: 1 };
